/**
 * Send a postMessage event to the parent window or opener.
 * Used for iframe/popup communication with embedding applications.
 * Supports both iframe (window.parent) and popup (window.opener) modes.
 *
 * @param {string} eventName - The event name (e.g., 'pandium-cancel')
 * @param {object} options - Optional data to include
 * @param {object} options.tenant - Tenant object (will be formatted automatically)
 * @param {object} options.data - Additional data to spread into the message
 */
export const sendPandiumEvent = (eventName, { tenant, ...data } = {}) => {
    const message = {
        message: eventName,
        ...data,
    }

    if (tenant) {
        message.tenant = {
            id: tenant.id,
            name: tenant.name,
            integration: {
                id: tenant.integration?.id,
                name: tenant.integration?.name,
            },
        }
    }

    const dest = window.opener ?? window.parent
    dest.postMessage(message, '*')
}
